import React, { useState, useEffect } from "react";
import { IoCloseCircleOutline } from "react-icons/io5";
import { updateSettings } from "Services/ServiceRequest";
import Swal from "sweetalert2";
import { useForm } from "react-hook-form";
import Modal from "react-modal";
import ReactLoading from "react-loading";
function AddUser({
    setModal,
    showModal,
    GetRequests,
    selectedItem,
    addSpacesToCamelCase,
}) {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const {
        register,
        handleSubmit,
        reset,
        setValue,
        formState: { errors },
    } = useForm();
    const closeModal = () => {
        if (!loading) {
            setModal(false);

            localStorage.removeItem("prefillData");
        }
    };
    useEffect(() => {
        setValue("value", selectedItem.value);
    }, [selectedItem]);
    const onSubmit = async (data) => {
        setLoading(true);

        try {
            const response = await updateSettings(selectedItem?.configId, {
                ...data,
                key: selectedItem?.key,
            });
            setLoading(false);
            if (response?.data?.Status === 1) {
                GetRequests();
                Swal.fire({
                    title: "Success",
                    text: response?.data?.Message || "Admin Update Successfull",
                    icon: "success",
                });
                closeModal();
            } else {
                setError(
                    error?.response?.data?.error?.name ||
                        response?.data?.Message ||
                        "Something went wrong please try again"
                );
            }
        } catch (err) {
            setLoading(false);
            setError(
                err?.response?.data?.Message ||
                    "Something went wrong please try again"
            );
        }
    };

    return (
        <Modal
            Modal
            isOpen={showModal}
            contentLabel="Modal"
            className={"modal"}
            onRequestClose={closeModal}
            overlayClassName={"overlay"}>
            <div className="form_wrapper_Modal">
                <header>
                    <h3>Update Config Details</h3>
                    <button onClick={closeModal} disabled={loading}>
                        <IoCloseCircleOutline />
                    </button>
                </header>
                <form
                    form
                    onSubmit={handleSubmit(onSubmit)}
                    className="Add_form">
                    <div
                        className="Form_Control"
                        style={{ gridColumn: "1/-1" }}>
                        <label htmlFor="">
                            {addSpacesToCamelCase(selectedItem.key)}
                        </label>
                        <input
                            className={errors.value ? "error" : ""}
                            {...register("value", { required: true })}
                        />
                        {errors.value && <span>This field is required</span>}
                    </div>

                    {error.length > 0 && (
                        <p
                            className="full-width"
                            style={{ color: "red", fontSize: "0.9rem" }}>
                            {error}
                        </p>
                    )}
                    <div className="add_form_btns full-width">
                        <button type="submit" disabled={loading}>
                            {loading ? (
                                <ReactLoading
                                    color="blue"
                                    type="spokes"
                                    height={20}
                                    width={20}
                                />
                            ) : (
                                "Update"
                            )}
                        </button>
                        <button
                            type="button"
                            onClick={closeModal}
                            disabled={loading}>
                            Cancel
                        </button>
                    </div>
                </form>
            </div>
        </Modal>
    );
}

export default AddUser;
